var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8002 16.7801C22.8002 17.6518 22.3316 18.4572 21.571 18.8931L13.2293 23.6731C12.4687 24.109 11.5317 24.109 10.771 23.6731L2.42934 18.8931C1.66874 18.4572 1.2002 17.6518 1.2002 16.7801L1.2002 7.21996C1.2002 6.34824 1.66874 5.54278 2.42934 5.10692L10.771 0.326884C11.5317 -0.108961 12.4687 -0.108961 13.2293 0.326884L21.571 5.10692C22.3316 5.54278 22.8002 6.34824 22.8002 7.21996V16.7801Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53525 14.775L7.22191 12.4617C6.96191 12.2017 6.54191 12.2017 6.28191 12.4617C6.02191 12.7217 6.02191 13.1417 6.28191 13.4017L9.06858 16.1883C9.32858 16.4483 9.74858 16.4483 10.0086 16.1883L17.0619 9.135C17.3219 8.875 17.3219 8.455 17.0619 8.195C16.8019 7.935 16.3819 7.935 16.1219 8.195L9.53525 14.775Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.d47192fcc3959f962b8dd01048f308c8.svg";
export { ForwardRef as ReactComponent };